module.exports = __webpack_public_path__ + "static/media/wicket1.5f443ed2.png";